export const config = {
  geminiApiKey: "AIzaSyCzD9uDGg24X1ZTt5d2pXDIo_xZjXQbOe8",
  maxFileSize: 5 * 1024 * 1024, // 5MB
  supportedImageTypes: ['image/jpeg', 'image/png', 'image/webp'],
  defaultCurrency: '¥',
}; 